module.exports = __webpack_public_path__ + "img/5.0c02276b.jpg";